import { copyToClipboard as copyToClipboardFn } from "helpers/copyToClipboard"
import { useCallback, useEffect, useRef, useState } from "react"

interface UseCopyToClipboardProps {
  content: string | (() => string)
  label?: string
}

export const useCopyToClipboard = ({
  content,
  label = "Copy text",
}: UseCopyToClipboardProps) => {
  const [copyText, setCopyText] = useState(label)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  const copyToClipboard = useCallback(() => {
    setCopyText("Copied")
    const textContent = typeof content == "function" ? content() : content
    copyToClipboardFn(textContent)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setCopyText(label)
    }, 3000)
  }, [content, label])

  return {
    copyText,
    copyToClipboard,
  }
}
